module.exports = __webpack_public_path__ + "static/media/popz.3c3938cf.png";